import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
import { Spin } from 'antd';
import { listarHomologacoesPorCliente } from '../api/homologacao';

export default function HomologacaoRouterPage() {
  const { clienteId } = useParams<{ clienteId: string }>();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  const nome = searchParams.get('nome') || '';

  useEffect(() => {
    if (!clienteId) return;

    const id = Number(clienteId);

    listarHomologacoesPorCliente(id)
      .then((lista) => {
        // Considera apenas ativas; inativadas são ignoradas (usuário pode criar nova).
        const ativas = lista.filter((h) => h.ativa !== 0);
        // Homologação finalizada/enviada/aprovada → detalhes
        const finalizada = ativas.find((h) =>
          ['finalizado', 'enviado', 'aprovado'].includes(h.status)
        );
        if (finalizada) {
          navigate(`/homologacao/detalhes/${finalizada.id}`, { replace: true });
          return;
        }

        // Rascunho em aberto → editar
        const rascunho = ativas.find((h) => h.status === 'rascunho');
        if (rascunho) {
          navigate(`/homologacao/${rascunho.id}`, { replace: true });
          return;
        }

        // Nenhuma → novo formulário
        const params = new URLSearchParams();
        if (nome) params.set('nome', nome);
        // Repassa outros params da URL original
        for (const [key, val] of searchParams.entries()) {
          if (key !== 'nome') params.set(key, val);
        }
        const qs = params.toString();
        navigate(`/homologacao/novo/${clienteId}${qs ? `?${qs}` : ''}`, { replace: true });
      })
      .catch(() => {
        // Se der erro na API, abre novo formulário
        navigate(`/homologacao/novo/${clienteId}?nome=${encodeURIComponent(nome)}`, { replace: true });
      })
      .finally(() => setLoading(false));
  }, [clienteId]);

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spin size="large" tip="Verificando homologações..." />
      </div>
    );
  }

  return null;
}
